import React from "react";
import cs from "classnames";
import classes from "./ColoringPageButton.module.scss";
import Icon, { NAMES } from "../Icon";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

const ColoringPageButton = ({ pdfHandler, size }) => {
  const { t } = useTranslation();

  return (
    <div className={cs(classes.previewButton, classes[size])} onClick={pdfHandler}>
      <Icon size="s" name={NAMES.PdfBlack} />
      {t("pages.mymaor.preview_button.coloring_page")}
    </div>
  );
};

ColoringPageButton.propTypes = {
  pdfHandler: PropTypes.func.isRequired,
  size: PropTypes.string.isRequired,
};

export default ColoringPageButton;
